import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getRegionForServiceShop = createAsyncThunk('/getRegionForServiceShop', async () => {
  const response = await axios.get('/GetRegionForServiceShop');
  return response.data;
});

export const getServiceShopForRegion = createAsyncThunk('/GetServiceShopForRegion', async (parentSourceServiceShopId) => {
    const response = await axios.get(`/GetServiceShopForRegion/${parentSourceServiceShopId}`);
    return response.data;
});

export const getServiceShopMaterials = createAsyncThunk('/GetServiceShopMaterials',
async (ids) => {
  const response = await axios.get(`/GetServiceShopMaterials/${ids[0]}/${ids[1]}/${ids[2]}`);
  return response.data;
});

export const getServiceShopOffWorkTask = createAsyncThunk('/GetServiceShopOffWorkTask',
async (ids) => {
  const response = await axios.get(`/GetServiceShopOffWorkTask/${ids[0]}/${ids[1]}/${ids[2]}`);
  return response.data;
});

export const getTechnicianOffWorkTask = createAsyncThunk('/GetTechnicianOffWorkTask',
async (ids) => {
  const response = await axios.get(`/GetTechnicianOffWorkTask/${ids[0]}/${ids[1]}/${ids[2]}`);
  return response.data;
});

export const getServiceShopPostCode = createAsyncThunk('/GetServiceShopPostCode',
async (ids) => {
  const response = await axios.get(`/GetServiceShopPostCode/${ids[0]}/${ids[1]}`);
  return response.data;
});




const serviceShopMaterialSlice = createSlice({
    name: 'serviceShopMaterial',
    initialState: {
      loading: false,
      error: '',
      RegionServiceControl: [],
      SubServiceShopControl: [],
      ServiceShopMaterials:[],
      SelectedAppTranslationId: 0,
      ServiceOffWork:[],
      PostCode:[]
    },
    reducers: {
      changeSelectedAppTranslationId(state, action) {
        state.SelectedAppTranslationId = action.payload;
      },
      resetDescriptions(state) {
        state.RegionServiceControl = [];
      },
    },
    extraReducers: {
      [getRegionForServiceShop.pending]: (state) => {
        state.loading = true;
      },
      [getRegionForServiceShop.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getRegionForServiceShop.fulfilled]: (state, action) => {
        state.RegionServiceControl = action.payload;
        state.loading = false;
      },
      [getServiceShopForRegion.pending]: (state) => {
        state.loading = true;
      },
      [getServiceShopForRegion.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getServiceShopForRegion.fulfilled]: (state, action) => {
        state.SubServiceShopControl = action.payload;
        state.loading = false;
      },
      [getServiceShopMaterials.pending]: (state) => {
        state.loading = true;
      },
      [getServiceShopMaterials.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getServiceShopMaterials.fulfilled]: (state, action) => {
        state.ServiceShopMaterials = action.payload;
        state.loading = false;
      },
      [getServiceShopOffWorkTask.pending]: (state) => {
        state.loading = true;
      },
      [getServiceShopOffWorkTask.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getServiceShopOffWorkTask.fulfilled]: (state, action) => {
        state.ServiceOffWork = action.payload;
        state.loading = false;
      },
      [getServiceShopPostCode.pending]: (state) => {
        state.loading = true;
      },
      [getServiceShopPostCode.rejected]: (state, action) => {
        state.error = action.payload;
        state.loading = false;
      },
      [getServiceShopPostCode.fulfilled]: (state, action) => {
        state.PostCode = action.payload;
        state.loading = false;
      },
    }
  });
  export const serviceShopMaterialActions = serviceShopMaterialSlice.actions;
  export default serviceShopMaterialSlice;